import { Calc } from "@/tools/BN";
import BigNumber from "bignumber.js";

const reorgan = (data, diff, method, needSort = false) => {
  // console.log("reorgan", data);
  if (!data.length) return data;

  let sortData = data;

  if (needSort) {
    sortData = data.sort((a, b) => b.price - a.price);
  }

  const result = [];

  for (let i = 0; i < sortData.length; i++) {
    result[i] = [sortData[i].price, sortData[i].sum];

    if (i === sortData.length - 1) {
      const diffPrice = Calc.init(result[0][0])[method](diff).result(false);

      if (Number(diffPrice) !== Number(result[sortData.length - 1][0])) {
        result[sortData.length] = {
          value: [diffPrice, result[sortData.length - 1][1]],
          symbolSize: 0,
        };
      }
    }
  }

  result.unshift({ value: [result[0][0], "0"], symbolSize: 0 });

  return result;
};

export default {
  namespaced: true,
  state: () => ({}),
  getters: {
    maxDiffDepth: (state, getters, rootState, rootGetters) => {
      const asksSum = rootGetters["orderBook/asksSum"];
      const bidsSum = rootGetters["orderBook/bidsSum"];

      const asksSumResult = Calc.setBN({ DECIMAL_PLACES: 18 })
        .init(asksSum.length ? asksSum[asksSum.length - 1].price : 0)
        .minus(asksSum.length ? asksSum[0].price : 0)
        .result(false);

      const bidsSumResult = Calc.setBN({ DECIMAL_PLACES: 18 })
        .init(bidsSum.length ? bidsSum[0].price : 0)
        .minus(bidsSum.length ? bidsSum[bidsSum.length - 1].price : 0)
        .result(false);

      return BigNumber.maximum(asksSumResult, bidsSumResult).valueOf();
    },
    reorganAskDepth: (state, getters, rootState, rootGetters) =>
      reorgan(rootGetters["orderBook/asksSum"], getters.maxDiffDepth, "plus"),
    reorganBidDepth: (state, getters, rootState, rootGetters) =>
      reorgan(rootGetters["orderBook/bidsSum"], getters.maxDiffDepth, "minus"),
  },
  mutations: {},
  actions: {},
};
